import React from "react";
import {
  AccountTree,
  ArrowBack,
  ArrowForward,
  TravelExplore,
  Contacts,
} from "@mui/icons-material";
import {
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { Link as RouterLink, Navigate } from "react-router-dom";
import { FruitifyContainer } from "../../../shared-components/Containers";
import { useAuthenticationStore } from "../../../stores/auth";

import { useApiClient } from "../../../api";
import OutreachMetrics from "../onboarding/OutreachMetrics";

export default function OutreachPage() {
  const { marketing: api } = useApiClient();
  const user = useAuthenticationStore((state) => state.user);
  const isSuperuser = user?.info?.activeContext?.contextType === "superuser";
  if (!isSuperuser) return <Navigate to="/" replace />;

  return (
    <FruitifyContainer>
      <Stack spacing={3}>
        <div>
          <Button
            component={RouterLink}
            to="/superuser/marketing"
            startIcon={<ArrowBack />}
          >
            Back to marketing
          </Button>
          <Typography variant="h4">Outreach</Typography>
          <Typography color="text.secondary">
            Find prospective school contacts and prepare outreach journeys for
            people who are not yet Fruitify users.
          </Typography>
        </div>
        <OutreachMetrics api={api} />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card variant="outlined" sx={{ height: "100%" }}>
              <CardContent sx={{ height: "100%", boxSizing: "border-box" }}>
                <Stack spacing={2} height="100%">
                  <Contacts color="primary" sx={{ fontSize: 38 }} />
                  <Typography variant="h5">Contacts</Typography>
                  <Typography color="text.secondary" flex={1}>
                    Search, review and validate all discovered outreach
                    contacts.
                  </Typography>
                  <Button
                    component={RouterLink}
                    to="/superuser/marketing/outreach/contacts"
                    endIcon={<ArrowForward />}
                  >
                    Manage contacts
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card variant="outlined" sx={{ height: "100%" }}>
              <CardContent sx={{ height: "100%", boxSizing: "border-box" }}>
                <Stack spacing={2} height="100%">
                  <TravelExplore color="primary" sx={{ fontSize: 38 }} />
                  <Typography variant="h5">Contact enrichment</Typography>
                  <Typography color="text.secondary" flex={1}>
                    Select schools and subjects, discover publicly evidenced
                    contacts and review the results.
                  </Typography>
                  <Button
                    component={RouterLink}
                    to="/superuser/marketing/outreach/enrichment"
                    endIcon={<ArrowForward />}
                  >
                    Enrich contacts
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card variant="outlined" sx={{ height: "100%" }}>
              <CardContent sx={{ height: "100%", boxSizing: "border-box" }}>
                <Stack spacing={2} height="100%">
                  <AccountTree color="primary" sx={{ fontSize: 38 }} />
                  <Typography variant="h5">Outreach workflows</Typography>
                  <Typography color="text.secondary" flex={1}>
                    Create and manage outreach journeys for verified school
                    contacts.
                  </Typography>
                  <Button
                    component={RouterLink}
                    to="/superuser/marketing/workflows"
                    endIcon={<ArrowForward />}
                  >
                    Manage outreach workflows
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Stack>
    </FruitifyContainer>
  );
}
